import React, { Component } from 'react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import { MdClear } from 'react-icons/md';
import { ArrowLeft2 } from 'iconsax-react';

import { Rating } from '@qbot-chat/qbot-uikit/chat';

import {
  goBack,
  navigate,
  navigateReplace,
} from '../../../../helper/HistoryHelper';
import { chatStore, rSocket } from '../../../../store/FrontChatStore';
import companyStore from '../../../../store/CompanyStore';

import BouncingDots from '../../../loading/components/BouncingDots';

import Styles from './HyundairsRatingView.module.scss';

const HYUNDAIRS_COMPANY_ID = '35';

@observer
class HyundairsRatingView extends Component {
  constructor(props) {
    super(props);
    makeObservable(this);
  }

  @observable
  isLoad = false;

  @observable
  message =
    `새롭게 도입한 디지털 상담 시스템(챗봇/채팅)은 보다 많은 고객들의 문의를 신속하게 처리하기 위함입니다.${'\n'}고객님의 만족도는 몇 점입니까?`;

  @action.bound
  async init() {
    let {
      match: { params },
    } = this.props;
    chatStore.setChannel({ id: params.channelId });
  }

  componentDidMount() {
    companyStore.fetchCompany(HYUNDAIRS_COMPANY_ID);

    this.isLoad = false;
    rSocket.requestChatApi(`/app/setting`).then(({ data }) => {
      this.message = data?.chatRatingMessage;
      if (!data.isEvaluationableByCustomer) {
        navigateReplace('/close');
      } else {
        this.isLoad = true;
        this.init().then();
      }
    });
  }

  render() {
    const company = companyStore.company;
    const symbolUrl = company?.symbolLogo?.fullUrl ?? null;
    const characterUrl =
      company?.logoFile?.fullUrl ?? company?.symbolLogo?.fullUrl ?? null;
    const companyName = company?.companyName ?? '현대렌탈서비스';

    return (
      <div className={Styles.Container}>
        <div className={Styles.HeaderContainer}>
          <div className={Styles.HeaderGradientBar} />
          <div className={Styles.Header}>
            <div className={Styles.HeaderLeft}>
              {this.isLoad && (
                <div
                  className={Styles.NavButton}
                  onClick={() => {
                    goBack();
                  }}
                >
                  <ArrowLeft2 size="24" />
                </div>
              )}
            </div>
            <div className={Styles.HeaderCenter}>
              {symbolUrl && (
                <img
                  src={symbolUrl}
                  alt={companyName}
                  className={Styles.LogoMini}
                />
              )}
              <span className={Styles.BrandName}>고객만족도조사</span>
            </div>
            <div className={Styles.HeaderRight}>
              {this.isLoad && (
                <div
                  className={Styles.NavButton}
                  onClick={() => {
                    chatStore.setChannel(null);
                    navigate('/close?isRating=false');
                  }}
                >
                  <MdClear size="24" />
                </div>
              )}
            </div>
          </div>
        </div>
        {this.isLoad ? (
          <Rating
            store={chatStore}
            message={this.message}
            onClosed={() => {
              chatStore.setChannel(null);
              navigate('/close?isRating=true');
            }}
          />
        ) : (
          <div className={Styles.LoadingWrap}>
            <div
              className="d-flex justify-center"
              style={{ margin: '40px 0 16px 0' }}
            >
              {characterUrl && (
                <img
                  src={characterUrl}
                  alt={companyName}
                  style={{
                    width: '200px',
                    height: '200px',
                    objectFit: 'contain',
                    backgroundColor: 'transparent',
                  }}
                />
              )}
            </div>
            <div className="d-flex flex-column justify-center align-items-center">
              <div>잠시만 기다려 주세요.</div>
            </div>
            <div
              className="d-flex justify-center"
              style={{ margin: '11px 0 27px 0' }}
            >
              <BouncingDots />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default HyundairsRatingView;
